import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["custom-button", [_ctx.buttonClass, { 'disabled': _ctx.disabled, 'active': _ctx.isActive }]]),
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
    disabled: _ctx.disabled,
    style: _normalizeStyle({ width: _ctx.customWidth })
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["button-content", [_ctx.contentClass]])
    }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.icon || _ctx.type === 'dropdown')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.type === 'dropdown' ? _ctx.iconDropdown : _ctx.icon,
            alt: _ctx.iconAlt,
            class: _normalizeClass(["button-icon", [_ctx.iconClass, { 'active': (_ctx.type === 'dropdown' && _ctx.isActive) }]]),
            onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleIconError && _ctx.handleIconError(...args)))
          }, null, 42, _hoisted_2))
        : _createCommentVNode("", true)
    ], 2)
  ], 14, _hoisted_1))
}